<template>
  <div class="info-flexible-combo">
    <KTCodePreview v-bind:title="title">
      <template v-slot:preview>
        <LoadingSpinner
          v-if="isLoadingComponent"
          :message="'Đang tải dữ liệu dealsheet...'"
        />
        <div v-else>
          <b-row
            v-for="row of notSupporteDetails"
            :key="row.id || row.productId || row.categoryId"
          >
            <b-col>
              <div
                class="warning-header"
                role="alert"
                style="width: 100%"
              >
                <div class="left-alert">
                  <inline-svg
                    src="media/svg/icons/other/warning-circle.svg"
                    width="24"
                    height="24"
                  ></inline-svg>
                </div>
                <div class="right-alert text-dark">
                  <p class="mb-0">
                    <span
                      v-if="row.categoryId"
                      class="text-primary"
                    >
                      Danh mục {{ row.categoryName || '-' }} chưa đạt chỉ tiêu
                    </span>
                    <span
                      v-else-if="row.productId"
                      class="text-primary"
                    >
                      Sản phẩm {{ row.productName }} chưa đạt chỉ tiêu
                    </span>
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="!notSupporteDetails.length && mainModel.id">
            <b-col>
              <div
                class="success-header"
                role="alert"
                style="width: 100%"
              >
                <div class="left-alert">
                  <inline-svg
                    src="media/svg/icons/other/success.svg"
                    width="24"
                    height="24"
                  ></inline-svg>
                </div>
                <div class="right-alert text-dark">
                  <span>Dealsheet mã {{ mainModel.code }} đã đạt chỉ tiêu</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="main">
            <b-col cols="4">
              <b-form-group class="required-control">
                <label>Tên chương trình</label>
                <b-form-input
                  size="sm"
                  v-model="mainModel.name"
                  placeholder="Nhập tên chương trình"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group class="required-control">
                <label>Mã chương trình</label>
                <b-form-input
                  size="sm"
                  v-model="mainModel.code"
                  placeholder="Nhập mã"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group class="required-control">
                <label>Loại chương trình</label>
                <b-form-select
                  size="sm"
                  class="select-style"
                  v-model="mainModel.programType"
                  :options="optionsProgramType"
                  value-field="id"
                  text-field="name"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null"
                      >-- Chọn loại chương trình --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group>
                <label>Trạng thái</label>
                <b-form-select
                  size="sm"
                  class="select-style"
                  v-model="mainModel.isActive"
                  :options="activeStatusOptions"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="4">
              <b-form-group class="required-control">
                <label>Thời gian áp dụng</label>
                <div class="d-flex justify-content-center align-items-center">
                  <date-picker
                    placeholder="Từ ngày"
                    class="form-control-sm"
                    :config="dpConfigs.date"
                    v-model="mainModel.startDate"
                  ></date-picker>
                  <span class="mx-2">-</span>
                  <date-picker
                    placeholder="Đến ngày"
                    class="form-control-sm"
                    :config="dpConfigs.date"
                    v-model="mainModel.endDate"
                  ></date-picker>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group class="required-control">
                <label>Điều kiện hỗ trợ MIN (%) - MAX (%)</label>
                <div class="d-flex align-items-center">
                  <b-form-input
                    size="sm"
                    v-model="mainModel.targetMin"
                    placeholder="Min"
                    class="text-right"
                    type="number"
                    min="0"
                  ></b-form-input>
                  <span class="mx-2">-</span>
                  <b-form-input
                    size="sm"
                    v-model="mainModel.targetMax"
                    placeholder="Max"
                    class="text-right"
                    type="number"
                    min="0"
                  ></b-form-input>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group class="required-control">
                <label>Loại chỉ tiêu</label>
                <b-form-select
                  size="sm"
                  class="select-style"
                  v-model="mainModel.targetType"
                  :options="optionsTargetType"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group>
                <label>Độ ưu tiên</label>
                <b-form-select
                  size="sm"
                  class="select-style"
                  v-model="mainModel.priority"
                  :options="optionsPriority"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-form-group>
                <label>Không áp dụng đồng thời với chương trình</label>
                <treeselect
                  :multiple="true"
                  v-model="mainModel.notApplicablePrograms"
                  :async="true"
                  :load-options="debouncedLoadOptions"
                  placeholder="Chọn chương trình loại trừ"
                  noResultsText="Không tìm thấy kết quả"
                  :searchable="true"
                  valueFormat="object"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="3"
            >
              <b-form-group :class="{ 'required-control': mainModel.targetType === DEAL_SHEET_TARGET_TYPE.SALE_IN }">
                <label>Nhà cung cấp</label>
                <SupplierAutosuggest
                  v-model="mainModel.providerId"
                  :initial-label="searchProvider"
                  allow-all
                  placeholder="tên nhà cung cấp"
                  :limit="10"
                  @selected="onSelectedProvider"
                  @input="(val) => { if(!val) onSelectedProvider(null) }"
                  :disabled="false"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="3"
            >
              <b-form-group>
                <label>Nhà cung cấp phụ</label>
                <SupplierAutosuggest
                  v-model="mainModel.subProviderId"
                  :initial-label="searchSubProvider"
                  allow-all
                  placeholder="tên nhà cung cấp phụ"
                  :limit="10"
                  @selected="onSelectedSubProvider"
                  @input="(val) => { if(!val) onSelectedSubProvider(null) }"
                  @search-change="(text) => { subProviderSearchText = text }"
                  @options-updated="(opts) => { subProviderOptionsCount = opts.length }"
                  :disabled="!mainModel.providerId"
                  :query-params="subProviderQueryParams"
                />
                <small
                  v-if="
                    subProviderSearchText && mainModel.providerId && subProviderOptionsCount === 0
                  "
                  class="form-text text-warning"
                >
                  <i class="fa fa-info-circle mr-1"></i>
                  Không có nhà cung cấp phụ nào thuộc nhà cung cấp chính đã chọn
                  <a
                    class="text-primary hover-link"
                    href="#"
                    @click.prevent="openListProviderInNewTab"
                    >Xem danh sách NCC</a
                  >.
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <b-form-group>
                <label>Phiếu đặt hàng nhập</label>
                <treeselect
                  :multiple="true"
                  v-model="mainModel.purchaseOrders"
                  :async="true"
                  :load-options="loadPurchaseOrderOptions"
                  placeholder="Nhập mã PO để tìm kiếm"
                  noResultsText="Không tìm thấy kết quả"
                  :searchable="true"
                  valueFormat="object"
                  :normalizer="normalizerPurchaseOrder"
                  retryText="Thử lại..."
                  retryTitle="Nhấp thử lại"
                  searchPromptText="Nhập mã PO để tìm kiếm..."
                  loadingText="Đang tải..."
                />
                <small class="form-text text-muted">
                  Chọn nhiều phiếu đặt hàng nhập gắn với dealsheet.
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="4">
              <b-form-group>
                <div class="d-flex justify-content-between align-items-center">
                  <span>
                    Danh sách IMEI:
                    <b-badge
                      variant="primary"
                      style="cursor: pointer"
                      @click="showIncludeImeisListModal"
                      >{{ includeImeisCount }}</b-badge
                    >
                  </span>
                  <b-button
                    type="button"
                    variant="secondary"
                    size="sm"
                    @click="showModalImportExcelIncludeImeis"
                  >
                    <i
                      style="font-size: 1rem"
                      class="far fa-file-excel"
                    ></i
                    >Nhập từ excel
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr
            class="hr-text"
            data-content="Chỉ tiêu kích hoạt"
            style="font-weight: 600"
            v-if="mainModel.targetType === DEAL_SHEET_TARGET_TYPE.SALE_OUT"
          />

          <b-row
            md-4
            v-if="mainModel.targetType === DEAL_SHEET_TARGET_TYPE.SALE_OUT"
          >
            <b-col md="6">
              <b-form-group label="Chọn cửa hàng">
                <treeselect
                  :options="stores"
                  :selected="mainModel.stores.storeId"
                  v-model="mainModel.stores"
                  :multiple="true"
                  :normalizer="normalizer"
                  :backspace-removes="false"
                  placeholder="Chọn cửa hàng"
                  :max-height="200"
                  noResultsText="Không tìm thấy kết quả"
                  valueFormat="object"
                  :clearable="false"
                >
                </treeselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="mainModel.targetType === DEAL_SHEET_TARGET_TYPE.SALE_OUT">
            <b-col md="8">
              <b-table
                class="col-md-12"
                bordered
                hover
                :fields="childFields"
                :items="mainModel.stores"
                :per-page="10"
                :current-page="currentPageStoreTable"
              >
                <template #cell(count)="row">
                  {{ row.item.count }}
                </template>
                <template v-slot:cell(targetQuantity)="row">
                  <b-input
                    type="text"
                    size="sm"
                    class="input-style text-right"
                    v-model="row.item.targetQuantity"
                    v-mask="mask"
                  ></b-input>
                </template>
                <template v-slot:cell(achieved)="row">
                  <span
                    :class="
                      row.item.achieved >= row.item.targetQuantity ? 'text-success' : 'text-danger'
                    "
                  >
                    {{ convertPrice(row.item.achieved) }}
                  </span>
                </template>
                <template v-slot:cell(actions)="row">
                  <i
                    class="flaticon2-rubbish-bin-delete-button text-danger"
                    role="button"
                    @click="
                      showDeleteAlert(
                        `${modalTitle} cửa hàng!`,
                        `${modalDesc} cửa hàng ${row.item.name}`,
                        row.item,
                        confirmDeleteStore,
                      )
                    "
                  >
                  </i>
                </template>
              </b-table>
              <b-row>
                <b-col>
                  <p
                    class="mt-3 text-dark"
                    style="font-weight: 500"
                  >
                    Tổng số:
                    {{ mainModel.stores.length }}
                  </p>
                </b-col>
                <b-pagination
                  class="custom-pagination"
                  v-show="mainModel.stores.length > 10"
                  v-model="currentPageStoreTable"
                  :total-rows="mainModel.stores.length"
                  :per-page="10"
                  align="right"
                >
                </b-pagination>
              </b-row>
            </b-col>
          </b-row>
          <div class="my-5"></div>
          <hr
            class="hr-text"
            data-content="Sản phẩm"
            style="font-weight: 600"
          />

          <DealSheetDetails
            :dealsheetDetails="dealsheetDetails"
            :selectedCategory="selectedCategory"
            :categories="categories"
            :mainModel="mainModel"
            @update:dealsheetDetails="dealsheetDetails = $event"
            @update:selectedCategory="selectedCategory = $event"
          />
        </div>
        <ImportDealSheetIncludeImeisModal
          ref="modal-import-excel-include-imeis"
          @update-include-imeis="handleUpdateIncludeImeis"
        />
        <IncludeImeisListModal
          ref="include-imeis-list-modal"
          :include-imeis="normalizedIncludeImeis"
          @update-include-imeis="handleRemoveIncludeImeis"
        />
      </template>
      <template v-slot:foot>
        <b-button
          v-if="
            (mainModel.id && checkPermission('DEALSHEET_UPDATE')) ||
            (!mainModel.id && checkPermission('DEALSHEET_INSERT'))
          "
          v-bind:style="btnCreate"
          size="sm"
          variant="primary"
          class="font-weight-bolder mr-4"
          :disabled="isBusy || isLoadingComponent"
          @click="onSubmit()"
        >
          Lưu
          <Spinner
            :show="isBusy || isLoadingComponent"
            custom-class="ml-2"
          />
        </b-button>
        <b-button
          v-bind:style="btnCreate"
          size="sm"
          variant="secondary"
          class="font-weight-bolder"
          @click="onBack"
        >
          Hủy
        </b-button>
      </template>
    </KTCodePreview>
  </div>
</template>
<style lang="scss" scoped>
label {
  font-weight: 500;
}

.success-header,
.alert-header,
.warning-header {
  border: 1px solid transparent;
  border-radius: 0.25rem;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 20px;
  line-height: 2rem;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1.5rem;
}

.warning-header {
  background: #fcf1ef;
  color: #333238;
}

.success-header {
  background: #90d79d;
  color: #ffffff;
}

.purchase-orders-header {
  border: 1px solid #b3d7ff;
  border-radius: 0.25rem;
  align-items: center;
  display: flex;
  padding: 0.75rem 1.25rem;
  background-color: #cce5ff;
  color: #004085;
  flex-wrap: wrap;
  .badge {
    font-size: 0.875rem;
  }
}

.right-warning,
.right-alert {
  display: flex;
  flex-direction: column;
}

.warning-header p,
.alert-header p {
  margin-bottom: 0;
}

.warning-header p:first-child {
  font-weight: 500;
  font-size: 1.125rem;
}

.alert-header {
  color: #856404;
  background-color: #fff3cd;
}

.main ::v-deep {
  .input-style {
    border: 1px solid #ced4da;
  }

  input.form-control {
    border: 1px solid #ced4da;
  }

  .muti-basic-custom .rounded {
    border-radius: 0.28rem !important;
  }

  .multi-select-wrapper {
    flex: 1 1 auto;
  }

  .table {
    th,
    td {
      padding: 0.75rem;
      vertical-align: middle;
      border-top: 1px solid #ecf0f3;
    }
  }
}
</style>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import { DEAL_SHEET_TARGET_TYPE, AMOUNT_TYPE, TARGET_TYPE } from '@/utils/enum'
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
import ApiService from '@/core/services/api.service'
import { showDeleteAlert } from '@/utils/sweet-alert2'
import datePicker from 'vue-bootstrap-datetimepicker'
import { validationMixin } from 'vuelidate'
import { getToastInstance } from '@/utils/toastHelper'
import debounce from 'debounce'
import { TIME_TRIGGER } from '@/utils/constants'
import { currencyMask, makeToastFaile, convertPrice } from '@/utils/common'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { normalizeCategory } from '@/utils/normalize-category'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import _ from 'lodash'
import { cloneDeep } from 'lodash'
import SupplierAutosuggest from '@/view/components/suppliers/SupplierAutosuggest.vue'
import { DP_CONFIG } from '@/utils/date'
import {
  PRIORITY_OPTIONS,
  PROGRAM_TYPE_OPTIONS,
  TARGET_TYPE_OPTIONS,
  ACTIVE_STATUS_OPTIONS,
  SEARCH_TYPE,
  DEFAULT_PRIORITY,
} from './utils/constants'
import { validateDealSheetForm } from './utils/validation'
import {
  initDealSheetPayload,
  createInitialFormModel,
  mapApiResponseToFormModel,
} from './utils/formHelper'
import { fetchStores, searchDealSheets, fetchProviders } from './utils/apiHelpers'
import { createDealSheet, updateDealSheet, getDealSheetById } from './utils/dealSheetApi'
import { STORE_TABLE_FIELDS } from './utils/tableConfig'
import { formatSpecificDate, convertToDateSlash } from '@/utils/date'
import { DATE_FORMAT } from '@/utils/constants'
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
import Spinner from '@/view/base/design-system/molecules/Spinner.vue'
import { PRODUCT_RELATIONSHIP_TYPES } from '@/utils/constants'
import permissionMixin from '@/view/mixins/permission.mixin'
import Treeselect from '@riophae/vue-treeselect'
import DealSheetDetails from '@/view/components/dealsheet/DealSheetDetails.vue'
import ImportDealSheetIncludeImeisModal from '@/view/components/dealsheet/ImportDealSheetIncludeImeisModal.vue'
import IncludeImeisListModal from '@/view/components/dealsheet/IncludeImeisListModal.vue'

export default {
  mixins: [validationMixin, permissionMixin],
  props: {
    // Khi mở từ modal danh sách: truyền id trực tiếp thay vì đọc từ route query
    dealSheetId: {
      type: [String, Number],
      default: null,
    },
    // Cờ đánh dấu đang nhúng trong modal (ẩn breadcrumb, dùng emit thay cho điều hướng route)
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DEAL_SHEET_TARGET_TYPE,
      AMOUNT_TYPE,
      TARGET_TYPE,
      normalizeCategory,
      modalDesc: 'Bạn có muốn xoá',
      modalTitle: 'Xoá ',
      notSupporteDetails: [],
      searchQuery: '',
      options: [],
      title: '',
      dpConfigs: DP_CONFIG,
      selectedCategory: [],
      optionsPriority: PRIORITY_OPTIONS,
      optionsProgramType: PROGRAM_TYPE_OPTIONS,
      optionsTargetType: TARGET_TYPE_OPTIONS,
      activeStatusOptions: ACTIVE_STATUS_OPTIONS,
      DATE_FORMAT: DATE_FORMAT,
      childFields: STORE_TABLE_FIELDS,
      mainModel: createInitialFormModel(DEFAULT_PRIORITY),
      dealsheetDetails: [],
      categories: [],
      isSearching: false,
      productTypes: PRODUCT_RELATIONSHIP_TYPES,
      importItems: [],
      file: null,
      excellist: [],
      fieldImport: [
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
        },
      ],
      importItemFor: [],
      fileFor: null,
      excellistFor: [],
      currentPageFor: 1,
      fieldImportFor: [
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
        },
      ],
      currentPageStoreTable: 1,
      mask: currencyMask,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      normalizerPurchaseOrder(node) {
        return {
          id: node.id,
          label: node.code || node.label || String(node.id),
        }
      },
      isBusy: false,
      stores: [],
      searchProduct: '',
      filteredItems: [],
      btnCreate: {
        fontWeight: '600!important',
        'margin-right': '-10px',
        width: '70px',
      },
      selectTypeSearch: 2,
      selectTypeOfProduct: 0,
      isLoadingComponent: false,
      searchProvider: '',
      filteredProviders: [],
      searchSubProvider: '',
      subProviderSearchText: '',
      subProviderOptionsCount: -1,
    }
  },
  components: {
    KTCodePreview,
    datePicker,
    Treeselect,
    SupplierAutosuggest,
    LoadingSpinner,
    Spinner,
    DealSheetDetails,
    ImportDealSheetIncludeImeisModal,
    IncludeImeisListModal,
  },
  watch: {},
  computed: {
    optionItems() {
      return [...cloneDeep(this.filteredItems)]
    },
    includeImeisCount() {
      return Array.isArray(this.mainModel.includeImeis) ? this.mainModel.includeImeis.length : 0
    },
    normalizedIncludeImeis() {
      return Array.isArray(this.mainModel.includeImeis) ? this.mainModel.includeImeis : []
    },
    // Giữ reference ổn định để watcher queryParams trong SupplierAutosuggest không fire mỗi lần re-render
    subProviderQueryParams() {
      return { parentId: this.mainModel.providerId }
    },
  },
  mounted() {
    this.title = 'Chi tiết dealsheet'
    const id = this.dealSheetId || this.$route.query.id
    if (id) {
      this.title = 'Cập nhật dealsheet '
      this.mainModel.id = id
      this.getInfoById()
    }
    if (!this.embedded) {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: this.title }])
    }
  },
  created() {
    this.getCategories()
    this.fetchStore()
    this.getProviders({ onlyParent: true })
  },
  methods: {
    showDeleteAlert,
    formatSpecificDate,
    linkToPurchaseOrder(po) {
      const route = this.$router.resolve({
        name: 'info-purchase-orders',
        query: { id: po.id },
      })
      window.open(route.href, '_blank')
    },
    openListProviderInNewTab() {
      const route = this.$router.resolve({ name: 'list-customer' })
      window.open(route.href, '_blank')
    },
    convertToDateSlash,
    ...getToastInstance(),
    convertPrice,
    getCategories() {
      ApiService.query('category')
        .then(({ data }) => {
          this.categories = data.data.list_caterogy || []
        })
        .catch(({ response }) => {
          makeToastFaile(response?.$error || 'Lỗi khi tải danh mục!')
        })
    },
    async getProviders(query) {
      this.filteredProviders = await fetchProviders(query)
      this.filteredSubProviders = this.mainModel.providerId
        ? await fetchProviders({ parentId: this.mainModel.providerId })
        : []
    },
    async onSelectedProvider(item) {
      if (item) {
        this.mainModel.providerId = item.id
        this.searchProvider = item.fullName || item.name
        this.mainModel.subProviderId = null
        this.searchSubProvider = ''
      } else {
        this.mainModel.providerId = null
        this.searchProvider = ''
        this.mainModel.subProviderId = null
        this.searchSubProvider = ''
      }
    },
    onSelectedSubProvider(item) {
      if (item) {
        this.mainModel.subProviderId = item.id
        this.searchSubProvider = item.fullName || item.name
      } else {
        this.mainModel.subProviderId = null
        this.searchSubProvider = ''
      }
    },
    confirmDeleteStore(deleteItem) {
      this.mainModel.stores = _.reject(this.mainModel.stores, (item) => {
        return item.id == deleteItem.id
      })
      this.mainModel.stores.forEach((element, index) => {
        element.count = index + 1
      })
    },
    debouncedLoadOptions({ action, searchQuery, callback }) {
      if (action === 'ASYNC_SEARCH') {
        this.handleSearchQueryChange(searchQuery, callback)
      }
    },
    handleSearchQueryChange: debounce(async function (searchQuery, callback) {
      this.searchQuery = searchQuery
      this.options = await searchDealSheets(this.searchQuery)
      if (this.options.length > 0) {
        callback(null, this.options)
      } else {
        callback(null, [])
      }
    }, TIME_TRIGGER),
    loadPurchaseOrderOptions({ action, searchQuery, callback }) {
      if (action === 'ASYNC_SEARCH') {
        this.handleSearchPurchaseOrders(searchQuery, callback)
      }
    },
    handleSearchPurchaseOrders: debounce(async function (searchQuery, callback) {
      try {
        const { data } = await ApiService.query('v1/purchase-orders/select', {
          params: { code: searchQuery || undefined },
        })
        const list = data?.data?.data ?? data?.data ?? (Array.isArray(data) ? data : [])
        const options = Array.isArray(list)
          ? list.map((po) => ({
              id: po.id,
              code: po.code,
              label: po.code || po.label || String(po.id),
            }))
          : []
        callback(null, options)
      } catch (err) {
        callback(null, [])
      }
    }, TIME_TRIGGER),
    onInputChangeSearch(text) {
      this.searchProduct = text
      this.debounceInputSearch()
    },
    onBack: function () {
      if (this.embedded) {
        this.$emit('close')
        return
      }
      history.back()
    },
    initPayload() {
      return initDealSheetPayload(
        this.mainModel,
        this.mainModel.stores,
        this.dealsheetDetails,
        this.selectedCategory,
      )
    },
    async onSubmit() {
      if (this.isBusy) return false

      if (!this.validate()) {
        return false
      }

      this.isBusy = true
      const payload = this.initPayload()
      try {
        if (payload.id) {
          await updateDealSheet(this.mainModel.id, payload)
        } else {
          await createDealSheet(payload)
        }
        if (this.embedded) {
          this.$emit('saved')
          this.$emit('close')
        } else {
          this.$router.push({
            name: 'deal-sheets',
          })
        }
      } finally {
        this.isBusy = false
      }
    },
    validate() {
      return validateDealSheetForm(this.mainModel, this.mainModel.stores, this.dealsheetDetails)
    },
    showModalImportProductFor() {
      this.importItems = []
      this.excellist = []
      this.$refs['import-product-for-modal'].show()
    },
    async fetchStore() {
      this.stores = await fetchStores()
    },
    debounceInputSearch: debounce(function () {
      if (!this.isSearching) {
        const textSearch = this.searchProduct ? this.searchProduct.trim() : null
        if (!textSearch) {
          return
        }
        if (this.selectTypeSearch === SEARCH_TYPE.BRAND) {
          this.searchBrand(textSearch)
        } else {
          this.searchItem(textSearch)
        }
      }
    }, TIME_TRIGGER),
    onSelectedStore() {
      this.mainModel.stores.forEach((item, index) => {
        item.count = index + 1
      })
    },
    searchItem(textSearch) {
      this.isSearching = true
      this.filteredItems = []
      const params = {
        searchProduct: textSearch,
        typeSearch: this.selectTypeSearch,
        typeOfProduct: this.selectTypeOfProduct,
      }
      ApiService.query(`productSearch/search-by-product-category`, {
        params,
      }).then((response) => {
        this.filteredItems = response.data?.data
        this.isSearching = false
      })
    },
    async getInfoById() {
      this.isLoadingComponent = true
      try {
        const result = await getDealSheetById(this.mainModel.id)

        Object.assign(this.mainModel, mapApiResponseToFormModel(result))

        const stores = result.stores || []

        this.mainModel.stores = stores.map((item, index) => ({
          ...item,
          count: index + 1,
          storeId: item.storeId || item.id,
          name: item.storeName || item.name || '',
        }))

        this.mainModel.notApplicablePrograms = (result.notApplicablePrograms || []).map((item) => ({
          ...item,
          label: item.name || item.label || item.code || '',
        }))

        this.notSupporteDetails = []
        this.dealsheetDetails = (result.details || []).map((item, index) => {
          if (item.notSupporteDetail) {
            this.notSupporteDetails.push(item.notSupporteDetail)
          }
          return {
            ...item,
            count: index + 1,
            discountType: item.discountType,
            discountPolicyType: item.discountPolicyType,
            targetType: item.targetType,
            categoryId: item.categoryId,
            categoryName: item.categoryName,
            notAchieved: !!item.notSupporteDetail,
          }
        })

        const fromResult =
          result.notSupporteDetails || (result.notSupporteDetail ? [result.notSupporteDetail] : [])
        this.notSupporteDetails = [...this.notSupporteDetails, ...fromResult]

        if (result.categories && result.categories.length > 0) {
          this.selectedCategory = result.categories.map((cat) => cat.id || cat)
        }

        if (this.filteredProviders.length === 0) {
          await this.getProviders({
            onlyParent: true,
          })
        }
        if (this.mainModel.providerId) {
          this.filteredSubProviders = await fetchProviders({
            parentId: this.mainModel.providerId,
          })
        }
        this.searchProvider = result.providerName || ''
        this.searchSubProvider = result.subProviderName || ''
      } catch (error) {
        console.error('Error loading dealsheet:', error)
      } finally {
        this.isLoadingComponent = false
      }
    },
    calSumDiscountRate() {
      this.mainModel.stores.forEach((x) => (x.discountRate = parseInt(x.discountRate)))
      return _.sumBy(this.mainModel.stores, 'discountRate')
    },
    searchBrand: function (textSearch) {
      this.listBrand = []
      const param = {
        page: 1,
        pageSize: 10,
        name: textSearch,
      }
      const paramQuery = {
        params: {
          param,
        },
      }
      ApiService.query('brands', paramQuery).then((response) => {
        this.filteredItems = response.data?.brands
      })
    },
    showModalImportExcelIncludeImeis() {
      this.$refs['modal-import-excel-include-imeis'].showModal(this.mainModel.id)
    },
    handleUpdateIncludeImeis(includeImeis) {
      this.mainModel.includeImeis = includeImeis
      const count = this.mainModel.includeImeis?.length || 0
      this.makeToastSuccess(`Đã cập nhật ${count} IMEI phát sinh`)
    },
    handleRemoveIncludeImeis(remaining) {
      this.mainModel.includeImeis = Array.isArray(remaining) ? remaining : []
    },
    showIncludeImeisListModal() {
      if (this.includeImeisCount === 0) {
        this.makeToastFailure('Chưa có IMEI phát sinh nào')
        return
      }
      this.$refs['include-imeis-list-modal'].showModal()
    },
  },
}
</script>
